import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

export const accordionItemBehavior = () => {
  Alpine.data('accordionItemBehavior', () => ({
    accordionItem: false,
    accordionItemButtonLabel: '',
    accordionItemOpen: false,
    init() {
      this.accordionItem = this.$el;
      this.accordionItemButtonLabel = this.accordionItem.querySelector(
        '.m-accordion-item__button__label'
      );
      this.accordionItemOpen = false;
    },
    bindAccordionItemButton: {
      // eslint-disable-next-line func-names
      '@click': function () {
        this.accordionItemOpen = !this.accordionItemOpen;

        try {
          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: this.accordionItemOpen ? 'accordion_open' : 'accordion_close',
            accordion_heading: this.accordionItemButtonLabel.textContent,
            page_url: window.location.href,
          });
          // eslint-disable-next-line no-empty
        } catch (err) {}
      },
    },
  }));
};
